var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Icon, Select, Table } from 'semantic-ui-react';
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { Plexity } from "../../KitDeserializer";
import { ProtocolTypeEnum } from "../automated-pro/EditKitForm";
import { checkChromogenCompatibility } from "../automated-pro/ProKitDetectForm";
import { TargetDesignType } from "../automated-pro/RnaCatalog";
import { priceColumn } from "../rna-fish/EditKitForm";
import { ComponentPriceDisplay } from "../rna-fish/ProbeSetForm";
var ManualProConsumerDetectForm = /** @class */ (function (_super) {
    __extends(ManualProConsumerDetectForm, _super);
    function ManualProConsumerDetectForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayChromogenNote = function () {
            return _this.props.detectState.chromogen.id === 'MATISSE_GREEN';
        };
        _this.priceDisplay = function () {
            return React.createElement(ComponentPriceDisplay, { loading: _this.props.priceLoading, effectivePriceCents: _this.props.effectivePriceCents, listPriceCents: _this.props.listPriceCents });
        };
        _this.onAmplifierChange = function (_, data) {
            var valStr = data.value;
            var enzyme = _this.props.catalog.proAmplifier.manualProAmps.proAmpConfigList.find(function (a) {
                return a.amplifier.id === valStr;
            });
            if (enzyme === undefined) {
                throw new RangeError("Invalid amplifier " + valStr);
            }
            _this.props.onDetectStateChange({
                enzyme: enzyme
            }, _this.props.onUserSelection);
        };
        _this.onChromogenChange = function (_, data) {
            var valStr = data.value;
            var chromogen = _this.props.catalog.proChromogens.chromogens
                .concat([{ id: 'NONE', label: 'NONE', platformCompatibility: [], enzymeCompatibility: '', bufferCompatibility: { id: 'NONE', label: 'NONE' } }])
                .find(function (c) { return c.id === valStr; });
            if (chromogen === undefined) {
                throw new RangeError("Invalid  chromogen " + valStr);
            }
            _this.props.onDetectStateChange({
                chromogen: chromogen,
                presetChromogenScale: findChromogenPresetScale(_this.props.catalog.presetScales, ProtocolTypeEnum.MANUAL, chromogen, _this.props.detectState.scale)
            }, _this.props.onUserSelection);
        };
        _this.onScaleChange = function (_, data) {
            var v = data.value;
            var newScale = _this.currentScales().find(function (s) { return s === v; });
            if (newScale === undefined) {
                throw new RangeError("Unknown scale value " + v);
            }
            var presetDetectScale = findDetectPresetScale(_this.props.catalog.presetScales, ProtocolTypeEnum.MANUAL, newScale, 1, _this.props.selectedSampleType.id === 'CELLS_SUSPENSION');
            var presetChromogenScale = findChromogenPresetScale(_this.props.catalog.presetScales, ProtocolTypeEnum.MANUAL, _this.props.detectState.chromogen, newScale);
            _this.props.onDetectStateChange({
                scale: newScale,
                presetDetectScale: presetDetectScale,
                presetChromogenScale: presetChromogenScale
            }, _this.props.onUserSelection);
        };
        _this.currentScales = function () {
            var scales = _this.props.catalog.manualProScaleOptions;
            if (scales === undefined) {
                throw new RangeError("Invalid scales");
            }
            // don't mess with the arrays in the catalog
            scales = Array.from(scales);
            scales.sort(function (s1, s2) { return s1 - s2; });
            return scales;
        };
        return _this;
    }
    ManualProConsumerDetectForm.prototype.render = function () {
        var _this = this;
        var protocolType = {
            id: ProtocolTypeEnum.MANUAL,
            label: ProtocolTypeEnum.MANUAL,
            alias: ProtocolTypeEnum.MANUAL,
            plexity: [Plexity.OnePlex],
            newLabel: false
        };
        var amplifierLabel = React.createElement(React.Fragment, null,
            "Amplifier ",
            React.createElement(Help, null,
                React.createElement("p", null, "HCR\u2122 Pro RNA-ISH kits require matching HCR\u2122 Pro Amplifier and HCR\u2122 HiFi Probe systems (e.g., X2 amplifier with an X2 HCR\u2122 HiFi Probe). HCR\u2122 Pro Amplifiers are available in X1\u2013X10."),
                React.createElement("p", { style: { marginBottom: 5 } }, "HCR\u2122 Pro Amplifier kit includes:"),
                React.createElement("ul", { style: { paddingLeft: 35, marginTop: 5 } },
                    React.createElement("li", null, "Pretreat"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect A"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect B"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect C"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect D"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect E"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect F HRP"),
                    React.createElement("li", null, "Post-Process")),
                React.createElement("p", { style: { marginBottom: 5 } }, "A complimentary Matisse\u00AE chromogen kit is also provided, which includes:"),
                React.createElement("ul", { style: { paddingLeft: 35, marginTop: 5 } },
                    React.createElement("li", null, "Matisse\u00AE Green or Matisse\u00AE Brown"),
                    React.createElement("li", null, "Matisse\u00AE Green Buffer or Matisse\u00AE Brown Buffer"))));
        var enzymeLabel = React.createElement(React.Fragment, null,
            "Enzyme ",
            React.createElement(Help, null, "HCR\u2122 Pro RNA-ISH kits integrate enzymatic signal amplification using horseradish peroxidase (HRP)."));
        var scaleLabel = React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "The HCR\u2122 Pro Amplifier kit is available at either small or large scales. For different sample types, representative reaction volumes and number of experiments are:",
                React.createElement("p", null),
                React.createElement(Table, { celled: true, striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "Small Scale"),
                            React.createElement(Table.HeaderCell, null, "Large Scale"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "10"),
                            React.createElement(Table.Cell, null, "50")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo)"),
                            React.createElement(Table.Cell, null, "200"),
                            React.createElement(Table.Cell, null, "5"),
                            React.createElement(Table.Cell, null, "25"))))));
        var chromogenLabel = React.createElement(React.Fragment, null,
            "Chromogen Kit ",
            React.createElement(Help, null,
                React.createElement("p", null,
                    "Use your HCR\u2122 Pro RNA-ISH kit with an HRP chromogen for RNA-CISH (e.g., a complimentary Matisse\u00AE chromogen optimized for use with HCR\u2122 Pro) or an HRP fluorogenic substrate for RNA-FISH (e.g., any of a variety of recommended third-party fluorescent tyramides; see table in ",
                    React.createElement("a", { href: "https://files.molecularinstruments.com/HCR\u2122-Pro-RNAISH-User-Guide.pdf" }, "HCR\u2122 Pro RNA-ISH User Guide"),
                    ")."),
                React.createElement("p", { style: { marginBottom: 5 } }, "Complimentary Matisse\u00AE chromogen kit includes:"),
                React.createElement("ul", { style: { paddingLeft: 35, marginTop: 5 } },
                    React.createElement("li", null, "Matisse\u00AE Green or Matisse\u00AE Brown"),
                    React.createElement("li", null, "Matisse\u00AE Green Buffer or Matisse\u00AE Brown Buffer"))));
        var sampleTypeSelected = this.props.selectedSampleType.id !== "";
        var scaleOptions = this.currentScales().map(function (s) {
            var numberOfSamples = calculateNumOfSamplesForAmp(s);
            if (_this.props.selectedSampleType.id === 'WHOLE_MOUNT' || _this.props.selectedSampleType.id === 'CELLS_SUSPENSION') {
                return {
                    text: React.createElement(React.Fragment, null,
                        numberOfSamples,
                        " samples"),
                    content: React.createElement(React.Fragment, null,
                        numberOfSamples,
                        " samples"),
                    value: s
                };
            }
            else if (_this.props.selectedSampleType.id === 'TISSUE_SECTION' || _this.props.selectedSampleType.id === 'CELLS_SLIDE') {
                return {
                    text: React.createElement(React.Fragment, null,
                        s,
                        " slides"),
                    content: React.createElement(React.Fragment, null,
                        s,
                        " slides"),
                    value: s
                };
            }
            else {
                return {
                    text: '',
                    content: null,
                    value: s
                };
            }
        });
        var ampCatalog = this.props.catalog.proAmplifier;
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/hcrAmplifier', errors: this.props.errors, labelContent: amplifierLabel, labelFor: 'amp-hcr-amplifier', showErrors: this.props.showErrors },
                        React.createElement(Select, { className: "label-dropdown", value: this.props.detectState.enzyme.amplifier.id, onChange: this.onAmplifierChange, options: ampCatalog.manualProAmps.proAmpConfigList
                                .map(function (c) {
                                return {
                                    text: c.amplifier.id,
                                    value: c.amplifier.id
                                };
                            }), name: 'amp-hcr-amplifier' }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/enzyme', errors: this.props.errors, labelContent: enzymeLabel, labelFor: 'amp-enzyme', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'amp-enzyme', className: "deactivated-dropdown", options: ampCatalog.manualProAmps.proAmpConfigList
                                .map(function (c) {
                                return {
                                    text: c.label,
                                    value: c.id
                                };
                            }), value: this.props.detectState.enzyme.id, disabled: true }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/scale', errors: this.props.errors, labelContent: scaleLabel, labelFor: 'amp-scale', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'amp-scale', className: this.props.detectState.scale ? "label-dropdown" : "deactivated-dropdown", value: this.props.detectState.scale ? this.props.detectState.scale : -1, disabled: !sampleTypeSelected || !this.props.detectState.scale, onChange: this.onScaleChange, options: scaleOptions })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/chromogen', errors: this.props.errors, labelContent: chromogenLabel, labelFor: 'chromogen', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'chromogen', className: "label-dropdown", value: this.props.detectState.chromogen.id, onChange: this.onChromogenChange, options: this.props.catalog.proChromogens.chromogens
                                .filter(function (c) {
                                return checkChromogenCompatibility(c, protocolType, _this.props.detectState.enzyme) &&
                                    _this.props.selectedSampleType.id !== "CELLS_SUSPENSION";
                            }).map(function (c) {
                                return {
                                    text: c.label,
                                    value: c.id
                                };
                            }).concat([{ text: 'None', value: 'NONE' }]), disabled: this.props.selectedSampleType.id === "CELLS_SUSPENSION" }))),
                this.displayChromogenNote() ?
                    React.createElement(Grid.Column, { style: { 'marginTop': '25px' } },
                        React.createElement(Icon, { style: { 'color': '#333333' }, name: 'lightbulb outline' }),
                        React.createElement("em", { style: { 'color': '#333333' } }, "Matisse\u00AE Brown is optimal for combining HCR\u2122 Pro RNA-CISH with traditional IHC assays.")) :
                    React.createElement(Grid.Column, null),
                React.createElement(Grid.Column, null),
                priceColumn(this.priceDisplay(), this.props.effectivePriceCents !== this.props.listPriceCents)));
    };
    return ManualProConsumerDetectForm;
}(React.PureComponent));
export { ManualProConsumerDetectForm };
export var calculateNumOfSamplesForAmp = function (scale) {
    return Math.round(scale / 2);
};
export var findProbePresetScale = function (presetScales, platform, variant, scale, plexity, channel) {
    return presetScales.presetProProbeScales.find(function (s) {
        var _a;
        return s.units === scale && s.platform.id === platform &&
            s.designType === ((_a = variant === null || variant === void 0 ? void 0 : variant.designType) !== null && _a !== void 0 ? _a : TargetDesignType.STANDARD) &&
            s.plexity === plexity &&
            s.channel === channel;
    });
};
export var findDetectPresetScale = function (presetScales, platform, newScale, plexity, proFlow) {
    return presetScales.presetProDetectScales.find(function (s) {
        return s.platform.id === platform &&
            s.units === newScale &&
            s.plexity === plexity &&
            s.isProFlow === proFlow;
    });
};
export var findChromogenPresetScale = function (presetScales, platform, chromogen, newScale) {
    return presetScales.presetProChromogenScales.find(function (s) {
        return s.platform.id === platform &&
            s.units === newScale &&
            s.chromogen.id === (chromogen === null || chromogen === void 0 ? void 0 : chromogen.id);
    });
};
//# sourceMappingURL=ManualProConsumerDetectForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-pro/ManualProConsumerDetectForm.js
// module id = 100
// module chunks = 0